import { Button } from 'primereact/button';
import { dateTimeFromBack, dateTimeStringF1, formatToJava } from '../../../util/dateUtils';
import {
    anularSiniestro,
    recuperaClienteSiniestro,
    recuperaConfDePadre,
    recuperaDatSiniestro
} from '../../../services/Siniestro/SiniestroService';
import { useCallback, useRef, useState } from 'react';
import { useEffect } from 'react';

export const useListaSiniestro = (funcNuevo, funcEdita, esAdmin) => {
    const [lstSiniestro, setLstSiniestro] = useState([]);
    const [ejecutaConfig, setEjecutaConfig] = useState(false);
    const [visibleConf, setVisibleConf] = useState(false);
    const [siniestro, setSiniestro] = useState({});
    const [cargaSiniestros, setCargaSiniestros] = useState(false);

    const [cliente, setCliente] = useState({});
    const [lstCliente, setLstCliente] = useState([]);
    const [cargaCliente, setCargaCliente] = useState(false);
    const [cambioCliente, setCambioCliente] = useState(false);

    const [proyecto, setProyecto] = useState({});
    const [lstProyecto, setLstProyecto] = useState([]);
    const [cargaProyecto, setCargaProyecto] = useState(false);
    const [cambioProyecto, setCambioProyecto] = useState(false);

    const [puesto, setPuesto] = useState({});
    const [lstPuesto, setLstPuesto] = useState([]);
    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [cambioPuesto, setCambioPuesto] = useState(false);

    const [fechaIni, setFechaIni] = useState();
    const [fechaFin, setFechaFin] = useState();

    const [visibleNeoCliente, setVisibleNeoCliente] = useState(false);
    const [visibleNeoProyecto, setVisibleNeoProyecto] = useState(false);
    const [visibleNeoPuesto, setVisibleNeoPuesto] = useState(false);
    const [visibleFuente, setVisibleFuente] = useState(false);
    const [visibleDocs, setVisibleDocs] = useState(false);

    const [parCliente, setParCliente] = useState({})
    const [parProyecto, setParProyecto] = useState({})
    const [parPuesto, setParPuesto] = useState({})

    const [visibleZonas, setVisibleZonas] = useState(false)
    const [visibleRutas, setVisibleRutas] = useState(false)
    const [visibleAsignaPuestos, setVisibleAsignaPuestos] = useState(false)
    const [visibleGrupos, setVisibleGrupos] = useState(false)

    const toast = useRef();

    const consultaSiniestro = useCallback(async (codCli, codProy, codPue, fechIn, fechFin) => {
        if (!fechIn) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe haber fecha Inicio'
            });
            return;
        }
        if (!fechFin) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe haber fecha Fin'
            });
            return;
        }

        const objPost = {
            //clienteConfId: codCli?.configuracionDetId ? codCli.configuracionDetId : 0,
            //proyectoConfId: codProy?.configuracionDetId ? codProy.configuracionDetId : 0,
            puestoConfId: codPue?.configuracionDetId ? codPue.configuracionDetId : 0,
            fechaInicial: formatToJava(fechIn),
            fechaFinal: formatToJava(fechFin),
            esAdmin: esAdmin
        };
        try {
            //console.log('JJJJ PARAMETROS: ', objPost);
            const data = await recuperaDatSiniestro(objPost);
            //console.log('JJJJ DATOS: ', data);
            const siniestros = data.map((item) => ({
                siniestroId: item.siniestroId,
                clienteId: item.clienteDet.id,
                clienteNombre: item.clienteDet.nombre,
                clienteCodigo: item.clienteDet.codigo,
                proyectoId: item.proyectoDet.id,
                proyectoNombre: item.proyectoDet.nombre,
                proyectoCodigo: item.proyectoDet.codigo,
                puestoId: item.puestoDet.id,
                puestoNombre: item.puestoDet.nombre,
                puestoCodigo: item.puestoDet.codigo,
                tipoSiniestroId: item.tipoSiniestroDet.configuracionDetId,
                tipoSiniestroNombre: item.tipoSiniestroDet.nombre,
                tipoSiniestroCodigo: item.tipoSiniestroDet.codigo,
                sectorConfigId: item.sectorConfigId,
                ubicacionId: item.ubicacion?.ubicacionId || 0,
                ubicacionNombre: item.ubicacion?.nombre || '',
                ubicacionCodigo: item.ubicacion?.codigo || '',
                fechaSiniestro: dateTimeStringF1(dateTimeFromBack(item.fecha)),
                puntoGPS: item.puntoGPS,
                descripcion: item.descripcion,
                esPrivado: item.esPrivado,
                usuarioCrea: item.usuarioCrea
            }));
            //console.log('JJJJ DATOS TRANSFORM: ', siniestros);
            setLstSiniestro(siniestros);
        } catch (err) {
            console.error('ERROR: ', err.message);
        }
    }, []);

    useEffect(() => {
        const hoy = new Date();
        setFechaFin(hoy);
        const iniSemana = new Date(hoy);
        const diaSemana = hoy.getDay();
        const diferencia = diaSemana === 0 ? -6 : 1 - diaSemana;
        iniSemana.setDate(hoy.getDate() + diferencia);
        setFechaIni(iniSemana);
        //
        try {
            setCargaSiniestros(true);
            consultaSiniestro(null, null, null, iniSemana, hoy);
        } catch (error) {
            console.error('ERROR: Error al obtener Lista de Sinietros');
        } finally {
            setCargaSiniestros(false);
        }
    }, [consultaSiniestro]);

    useEffect(() => {
        const recuperaClientes = async () => {
            try {
                setCargaCliente(true);
                const datos = await recuperaClienteSiniestro();
                setLstCliente(datos.data);
            } catch (error) {
                console.error('Error al obtener los Clientes de Siniestro');
            } finally {
                setCargaCliente(false);
            }
        };
        recuperaClientes();
    }, [cambioCliente]);

    useEffect(() => {
        const recuperaProyecto = async () => {
            try {
                setCargaProyecto(true);
                if (cliente?.configuracionDetId) {
                    const datos = await recuperaConfDePadre(cliente?.configuracionDetId);
                    //console.log ('DATOS PROYECTO..:', datos)
                    setLstProyecto(datos);
                }
            } catch (error) {
                console.error('Error al obtener Proyecto');
            } finally {
                setCargaProyecto(false);
            }
        };
        recuperaProyecto();
    }, [cliente, cambioProyecto]);

    useEffect(() => {
        const recuperarPuesto = async () => {
            try {
                setCargaPuesto(true);
                if (proyecto?.configuracionDetId) {
                    const datos = await recuperaConfDePadre(proyecto?.configuracionDetId);
                    setLstPuesto(datos);
                }
            } catch (error) {
                console.error('Error al obtener Puesto');
            } finally {
                setCargaPuesto(false);
            }
        };
        recuperarPuesto();
    }, [proyecto, cambioPuesto]);

    const borraSiniestro = async () => {
        try {
            setEjecutaConfig(true);
            //console.log('ENTRRADA: ', siniestro);
            const datos = await anularSiniestro(siniestro.siniestroId);
            //console.log('SALIDA: ', datos);
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Se ha anulado el Evento'
            });
            setVisibleConf(false);
            consultaSiniestro(cliente, proyecto, puesto, fechaIni, fechaFin);
        } catch (err) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se ha podido eliminar el Evento'
            });
        } finally {
            setEjecutaConfig(false);
        }
    };

    const footerConfirm = () => {
        return (
            <div>
                <Button
                    label="No"
                    icon="pi pi-times"
                    onClick={() => setVisibleConf(false)}
                    className="p-button-text"
                    disabled={ejecutaConfig}
                />
                <Button
                    label="Sí"
                    icon="pi pi-check"
                    onClick={borraSiniestro}
                    loading={ejecutaConfig}
                    autoFocus
                />
            </div>
        );
    };

    const handleBorrar = (row) => {
        setSiniestro(row);
        setVisibleConf(true);
    };

    const goToEdit = (dataFila) => {
        funcEdita(dataFila);
    };

    const verZonas = () => {
        setVisibleZonas (true)
    }

    const verRutas = () => {
        setVisibleRutas(true)
    }

    const verGrupos = () => {
        setVisibleGrupos(true)
    }

    const header = (
        <div className="flex justify-content-between align-items-center mb-4">
            <h2 className="m-0 font-bold" style={{ color: '#0D47A1' }}>Gestión de Eventos Delictivos y Operativos de Seguridad</h2>
            <div className="flex gap-2">
                <Button label="Asignar Puestos" icon='pi pi-users' onClick={() => setVisibleAsignaPuestos(true)} disabled={!esAdmin}/>
                <Button label="Grupos" icon='pi pi-sitemap' onClick={verGrupos} disabled={!esAdmin}/>
                <Button label="Zonas" icon='pi pi-comment' onClick={verZonas} disabled={!esAdmin}/>
                <Button label="Rutas" icon='pi pi-truck' onClick={verRutas}  disabled={!esAdmin}/>
                <Button
                    label="Crear Evento"
                    icon="pi pi-plus"
                    className="p-button-primary border-round-3xl px-4"
                    onClick={funcNuevo}
                />
            </div>
        </div>
    );

    const goToFuentes = (datoSin) => {
        setSiniestro(datoSin);
        setVisibleFuente(true);
    };

    const goToDoc = (datosSin) => {
        setSiniestro(datosSin);
        setVisibleDocs(true);
    };

    const actionBody = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                {/*<Button
                    icon="pi pi-file-edit"
                    className="p-button-rounded p-button-warning"
                    tooltip="Editar Documento"
                    onClick={() => goToDoc(rowData)}
                />*/}
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-warning"
                    tooltip="Ver Fuentes"
                    onClick={() => goToFuentes(rowData)}
                />
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-info"
                    tooltip="Editar Evento"
                    onClick={() => goToEdit(rowData)}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger"
                    tooltip="Eliminar Evento"
                    onClick={() => handleBorrar(rowData)}
                />
            </div>
        );
    };

    const handleConsulta = () => {
        try {
            setCargaSiniestros(true);
            consultaSiniestro(cliente, proyecto, puesto, fechaIni, fechaFin);
        } catch (error) {
            console.error('Error al Datos de Siniestro');
        } finally {
            setCargaSiniestros(false);
        }
    };

    return {
        footerConfirm,
        consultaSiniestro,
        toast,
        lstSiniestro,
        visibleConf,
        setVisibleConf,
        siniestro,
        setSiniestro,
        setFechaIni,
        setFechaFin,
        fechaIni,
        fechaFin,
        header,
        actionBody,
        cliente,
        setCliente,
        cargaCliente,
        lstCliente,
        proyecto,
        setProyecto,
        cargaProyecto,
        lstProyecto,
        puesto,
        setPuesto,
        cargaPuesto,
        lstPuesto,
        handleConsulta,
        cargaSiniestros,
        setCargaSiniestros,
        visibleNeoCliente,
        setVisibleNeoCliente,
        setCambioCliente,
        visibleNeoProyecto,
        setVisibleNeoProyecto,
        setCambioProyecto,
        visibleNeoPuesto,
        setVisibleNeoPuesto,
        setCambioPuesto,
        visibleFuente,
        setVisibleFuente,
        visibleDocs,
        setVisibleDocs,
        parCliente, setParCliente,parProyecto, setParProyecto,
        parPuesto, setParPuesto,
        visibleZonas, setVisibleZonas,
        visibleRutas, setVisibleRutas,
        visibleAsignaPuestos, setVisibleAsignaPuestos,
        visibleGrupos, setVisibleGrupos
    };
};

